export const CREATE_DEBIT_NOTE  = 'CREATE_DEBIT_NOTE';
export const GET_DEBIT_NOTES  = 'GET_DEBIT_NOTES';
export const GET_DEBIT_NOTES_PAGE  = 'GET_DEBIT_NOTES_PAGE';
export const DEBIT_NOTE_REQUEST  = 'DEBIT_NOTE_REQUEST';
export const DELETE_DEBIT_NOTE  = 'DELETE_DEBIT_NOTE';
export const UPDATE_DEBIT_NOTE  = 'UPDATE_DEBIT_NOTE';
export const DEBIT_NOTE_REQUEST_SUCCESS  = 'DEBIT_NOTE_REQUEST_SUCCESS';
export const DEBIT_NOTE_REQUEST_FAILURE  = 'DEBIT_NOTE_REQUEST_FAILURE';